import React from 'react';
import {ClipLoader} from 'halogenium';

export function Loading({ size = 32, color = '#000' }) {
  return (
    <div className="loading-wrapper">
      <ClipLoader size={size} color={color} />
    </div>
  ) ;
}



// WEBPACK FOOTER //
// ./src/components/common/loading.js